import { ContactSchedule } from './ContactSchedule';
import { Contacts } from './Contacts';

export const contactsRoutes = [
  { index: true, element: <Contacts /> },
  { path: ':contactId', children: [{ path: 'gantt', element: <ContactSchedule /> }] },
];
